<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.customers.retrieveLoader" transition="fade-transition" type="table" />
      <template v-else>

        <!-- list -->
        <v-data-table v-if="orgunits.length" :headers="headers" :items.sync="orgunits" :items-per-page="pagination" mobile-breakpoint hide-default-header disable-sort hide-default-footer>
          <template v-slot:[`header`]="{ props: { headers } }">
            <VTableHeaders :headers="headers" @sort="setSort" />
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
              <template v-slot:activator="{on, attrs}">
                <v-btn class="ml-2" v-bind="attrs" v-on="on" min-width="34" max-width="34" outlined color="secondary" :ripple="false" retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
              </template>
              <v-list class="pa-0">
                <v-list-item class="px-5 py-1" @click="setEditable(item)" :ripple="false">
                  <v-list-item-title class="subtitle-2 font-weight-medium">Editar</v-list-item-title>
                </v-list-item>
                <v-list-item class="px-5 py-1" @click="destroyOrgunit(item)" :ripple="false">
                  <v-list-item-title class="subtitle-2 red--text font-weight-medium">Eliminar</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
        <!-- end list -->

        <!-- empty list -->
        <v-row v-else>
          <v-col class="pb-6 pt-4 text-center">
            <v-icon class="d-block" color="secondary" size="70">mdi-sitemap</v-icon>
            <span class="d-block subtitle-1 my-2">No existen unidades organizativas</span>
            <v-btn @click="dialogOrgunitCreate = true" outlined>Crear una unidad organizativa</v-btn>
          </v-col>
        </v-row>
        <!-- end empty list -->

      </template>
    </v-col>

    <!-- dialog create -->
    <v-dialog v-model="dialogOrgunitCreate" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Crear unidad organizativa</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogOrgunitCreate=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-12 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>Nombre de la unidad organizativa</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="12">
                  <v-text-field v-model.trim="$v.newOrgunit.name.$model" :error="$v.newOrgunit.name.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer/>
          <v-btn outlined @click="dialogOrgunitCreate=false">Cancelar</v-btn>
          <v-btn color="primary" :loading="$store.state.customers.createLoader" @click="createOrgunit">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog create -->

    <!-- dialog update -->
    <v-dialog v-model="dialogOrgunitUpdate" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Editar unidad organizativa</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogOrgunitUpdate=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-12 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>Nombre de la unidad organizativa</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="12">
                  <v-text-field v-model.trim="$v.editableOrgunit.name.$model" :error="$v.editableOrgunit.name.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer/>
          <v-btn outlined @click="dialogOrgunitUpdate=false">Cancelar</v-btn>
          <v-btn color="primary" :loading="$store.state.customers.createLoader" @click="updateOrgunit">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog update -->

  </v-row>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { maxLength, required } from 'vuelidate/lib/validators'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  props: {
    customer: {
      type: Object,
      required: true
    },
    displayCreate: {
      type: Boolean,
      required: false,
      default: () => (false)
    }
  },
  data: () => ({
    dialogOrgunitCreate: false,
    dialogOrgunitUpdate: false,
    editableOrgunit: {
      id: '',
      name: ''
    },
    headers: [
      { text: 'Nombre', value: 'name', class: 'font-weight-bold', sortable: true },
      { text: '', value: 'actions', class: 'font-weight-bold', align: 'end', sortable: false }
    ],
    newOrgunit: {
      name: ''
    }
  }),
  computed: {
    ...mapState({
      count: state => state.customers.customersCount,
      orgunitsList: state => state.customers.orgunitsList
    }),
    ...mapGetters({
      orgunits: 'customers/orgunits'
    })
  },
  watch: {
    displayCreate () {
      if (this.displayCreate) {
        this.dialogOrgunitCreate = true
      }
    },
    dialogOrgunitCreate () {
      this.$emit('dialog-create', this.dialogOrgunitCreate)
    }
  },
  methods: {
    createOrgunit () {
      this.$v.newOrgunit.$touch()

      if (this.$v.newOrgunit.$invalid) {
        return false
      }

      const payload = Object.assign({}, this.newOrgunit, {
        customer: this.customer.id
      })

      this.$store.dispatch('customers/CREATE', {
        resource: 'orgunits',
        payload: payload
      })
      .then(() => {
        this.dialogOrgunitCreate = false
        this.newOrgunit.name = ''
        this.$v.newOrgunit.$reset()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    destroyOrgunit (item) {
      this.$dialog.warning({
        title: 'Eliminar unidad organizativa',
        text: `
          <span class="d-block my-4">Estás a punto de eliminar la unidad organizativa ${item.name}.
          Esta acción no se podrá realizar si la organización está asignada a al menos una suscripción
          o persona / contacto.</span>
          <span class="d-block my-4 font-weight-medium">Esta acción no se puede deshacer.</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('customers/DESTROY', {
                resource: 'orgunits',
                id: item.id
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    setEditable (item) {
      this.dialogOrgunitUpdate = true
      this.editableOrgunit = cloneDeep(item)
    },
    updateOrgunit () {
      this.$v.editableOrgunit.$touch()

      if (this.$v.editableOrgunit.$invalid) {
        return false
      }

      const payload = Object.assign({}, this.editableOrgunit, {
        customer: this.customer.id
      })

      this.$store.dispatch('customers/UPDATE', {
        resource: 'orgunits',
        id: this.editableOrgunit.id,
        payload: payload
      })
      .then(() => {
        this.dialogOrgunitUpdate = false
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    newOrgunit: {
      name: {
        required,
        maxLength: maxLength(64)
      }
    },
    editableOrgunit: {
      name: {
        required,
        maxLength: maxLength(64)
      }
    }
  }
}
</script>